import { AccountModel } from '../account';

export class UserModel {
    Id: number;
    AccountId: number;
    FirstName: string;
    LastName: string;
    EmailId: string;
    Password: string;
    IsActive: boolean;
    IsDeleted: boolean;
    CreatedOn: string;
    UpdatedOn: string;
    Account: AccountModel;

    constructor() {
        this.Id = 0;
        this.AccountId = 0;
        this.FirstName = '';
        this.LastName = '';
        this.EmailId = '';
        this.Password = '';
        this.IsActive = false;
        this.IsDeleted = false;
        this.CreatedOn = '';
        this.UpdatedOn = '';
        this.Account = new AccountModel();
    }
}
